module.exports = __webpack_public_path__ + "files/09e00b340f4be815bd9ee8a2c83cb7e6.png";